import React, { useCallback, useId, useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';

import Fieldset from '@rover/components/src/formFields/Fieldset';
import SingleSelectButtonGroup from '@rover/components/src/formFields/SingleSelectButtonGroup';
import { SelectedValue } from '@rover/react-lib/src/pages/search/SearchPage/components/Filters/Preferences/CatPreferences';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';
import FilterLabel from '@rover/shared/js/search/components/FilterLabel';

import { SearchInterstitialGetsAlongDogs } from '../Collections/Wizard/analyticsEvents';
import { TogglePreference } from '..';

type Props = {
  displayAsToggle?: boolean;
  onChange: (arg0: boolean) => void;
  value?: boolean;
};

const DogPreferences = ({ displayAsToggle, onChange, value = true }: Props): JSX.Element => {
  const id = useId();
  const [singleSelectValue, setSingleSelectValue] = useState<SelectedValue>(value ? 'no' : 'yes');

  const DOG_PREFERENCES_OPTIONS = [
    {
      value: 'yes',
      submitValue: false,
      title: t`Yes`,
    },
    {
      value: 'no',
      submitValue: true,
      title: t`No`,
    },
    {
      value: 'unsure',
      submitValue: false,
      title: t`Unsure`,
    },
  ];

  const handleSingleSelectChange = useCallback(
    (selectedValue: SelectedValue): void => {
      const clickedOption = DOG_PREFERENCES_OPTIONS.find(
        (option) => option.value === selectedValue
      );
      onChange(clickedOption ? clickedOption.submitValue : false);
      setSingleSelectValue(selectedValue);
    },
    [onChange]
  );

  return displayAsToggle ? (
    <TogglePreference
      label={t`My dogs don’t like other dogs`}
      onChange={(toggledValue) => {
        emitAnalyticsEvent(
          new SearchInterstitialGetsAlongDogs({ getsAlongDogs: toggledValue ? 'no' : 'yes' })
        );
        onChange(toggledValue);
      }}
      value={value}
    />
  ) : (
    <Fieldset aria-labelledby={id}>
      <FilterLabel id={id}>
        <Trans>Do your dogs get along with dogs?</Trans>
      </FilterLabel>
      <SingleSelectButtonGroup
        buttons={DOG_PREFERENCES_OPTIONS}
        id={id}
        onChange={(chosenValue) => {
          emitAnalyticsEvent(new SearchInterstitialGetsAlongDogs({ getsAlongDogs: chosenValue }));
          handleSingleSelectChange(chosenValue);
        }}
        value={singleSelectValue as SelectedValue}
      />
    </Fieldset>
  );
};

export default DogPreferences;
